<template>
  <div>
    <div class="robot-header fx">
      <!-- <i class="iconfont icon-jiqiren"></i> -->
      <img src="@/assets/newicons/ib01.png" style="width:16px;height:17px" alt="">
      <span>小T</span>
    </div>
    <div class="robot-body">
      <div class="tip">Hi，我是AI助手小T，我可以为您</div>
      <div>
        <div class="li fx-s-center" style="margin-bottom: 8px;" @click="clickRecommendClue">
          <div class="fx-none icon fx-ps-center"><i class="iconfont icon-zhinengtuijian"></i></div>
          <div class="fx-full cls001">推荐线索</div>
          <div class="fx-none">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <div class="li fx-s-center" style="margin-bottom: 8px;" @click="clickSubscribe">
          <i class="red-icon" v-if="unreadCount>0"></i>
          <div class="fx-none icon fx-ps-center"><i class="iconfont icon-sjdy"></i></div>
          <div class="fx-full cls001">商机订阅</div>
          <div class="fx-none">
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <!-- <el-badge :value="deepingTaskCount" style="width: 100%;" :hidden="!deepingTaskCount">
          <div class="li  fx-s-center" @click="clickDeep">
            <div class="fx-none icon fx-ps-center"><i style="font-size:20px;" class="iconfont icon-wajueji01"></i></div>
            <div class="fx-full cls001">深度挖掘</div>
            <div class="fx-none">
              <i class="el-icon-arrow-right"></i>
            </div>
          </div>
        </el-badge> -->
      </div>
    </div>

  </div>
</template>

<script>
import emitter from '@/mixins/emitter'
import {subscribeUnreadCount} from '@/views/clue/api/subscribeApi'

export default {
  name: "robotView",
  mixins: [emitter],
  components: {},
  props: {
    deepingTaskCount: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      unreadCount:0
    }
  },
  computed: {},
  mounted(){
     this.getSubscribeUnread()
  },
  methods: {
    // 小T小红点查询当前是否有未读消息数量
    getSubscribeUnread(){
        subscribeUnreadCount().then(res =>{
           if(res.code == 200){
                this.unreadCount = res.data
           }
        })
    },
    // 去线索
    clickRecommendClue() {
      this.dispatch('robot', 'activeIndexChange', 1)
    },
    // 去深度挖掘
    clickDeep() {
      this.dispatch('robot', 'activeIndexChange', 2)
    },
    // 去商机订阅
    clickSubscribe(){
      this.dispatch('robot', 'activeIndexChange', 3)
    }
  }
}
</script>

<style lang="scss" scoped>
.robot-header {
  position: absolute;
  top: 10px;
  left: 16px;
  display: flex;
  align-items: center;
  i {
    font-size: 24px;
    margin-right: 4px;
  }
  span {
    padding-top: 4px;
    color: #666666;
    font-size: 12px;
    margin-left: 4px;
  }
}
.robot-body {
  padding: 24px 4px 4px;
}
.tip {
  line-height: 24px;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  text-align:center;
  padding-top: 10px;
}
.li {
  height: 50px;
  background: rgba(52, 57, 81, 0.05);
  border-radius: 8px;
  cursor: pointer;
  padding: 13px 17px;
  position: relative;
  .icon {
    width: 26px;
    height: 26px;
    background: #fff;
    border-radius: 50%;
    i {
      color: #409eff;
      width: 26px;
      height: 26px;
      &.icon-sjdy{
          content: url("~@/assets/subscribe/icon-sjdy.png");
      }
      &.icon-zhinengtuijian{
          content: url("~@/assets/subscribe/icon-tjxs.png");
          
      }
    }
    margin-right: 9px;

  }
  .el-icon-arrow-right {
    font-size: 14px;
  }
  .red-icon{
    position: absolute;
    width: 10px;
    height: 10px;
    display:block;
    background: #FF5000;
    right: -4px;
    top: -4px;
    border-radius: 50%;
  }
}
.cls001{
  font-weight: 600;
  color: #666666;
}
</style>